import React, { useState } from "react";
import {
  Box,
  Grid,
  Typography,
  useMediaQuery,
  Button,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Divider,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import InstagramIcon from "@mui/icons-material/Instagram";
import TwitterIcon from "@mui/icons-material/Twitter";
import FacebookIcon from "@mui/icons-material/Facebook";
import YouTubeIcon from "@mui/icons-material/YouTube";
import EmailIcon from "@mui/icons-material/Email";
import targetImage from "../images/endorsements-header.jpeg";
import EmailSignupModal from "./EmailSignupModal";
import EventModal from "./EventModal";

const Endorsements = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [eventOpen, setEventOpen] = useState(false);
  const [emailOpen, setEmailOpen] = useState(false);

  const mediaItems = [
    {
      title: "Former County Executive Hon. Isiah 'Ike' Leggett",
    },
    {
      title: "Delegate Charlotte Crutchfield",
    },
    {
      title: "Congresswoman Eleanor Holmes Norton",
    },
    {
      title: "Delegate Diana Fennell",
    },
    {
      title: "Senator Nancy King",
    },
    {
      title: "School Board Member Brenda Wolff",
    },
    {
      title: "American Federation of Government Employees",
    },
   
  ];

  return (
    <Box sx={{ backgroundColor: "#1d2845" }}>
      {/* Header Section */}
      {/* Header */}
      <Box
        sx={{
          backgroundImage: `url(${targetImage})`,
          backgroundSize: "cover",
          backgroundPosition: isMobile ? "left" : "center",
          backgroundRepeat: "no-repeat",
          backgroundPositionY: "-40vh",
          height: isMobile ? "30vh" : "50vh",
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "flex-end",
          textAlign: "center",
          p: isMobile ? 2 : 4,
        }}
      >
        <Typography
          variant="h1"
          sx={{
            color: "white",
            fontWeight: "900!important",
            fontSize: {
              xs: "2.5rem",
              fontSize: isMobile ? "3rem!important" : "4rem!important",
              textTransform: "uppercase",
              fontWeight: "500!important",
              background: "#1d2845d1",
              borderRadius: "8px",
              padding: "8px 16px",
            },
          }}
        >
          Endorsements
        </Typography>
      </Box>

      {/* Body Section */}
      <Box p={isMobile ? "16px" : "48px 96px 48px"}>
        <Grid container>
          <Grid item xs={12}>
            <Typography
              variant="h5"
              sx={{ color: "#00853e!important", fontSize: "1.5rem!important" }}
              py={2}
            >
              <span
                style={{
                  marginRight: "4px",
                  lineHeight: "0",
                  color: "white",
                }}
              >
                "
              </span>
              I’ve know Jeremiah for xx years. I’ve watched him grow personally
              and professionally – always working hard to help other people. He
              is wise, intelligent, experienced and has the moral compass to do
              what is right for all of our community. Jeremiah understands the
              issues Montgomery County is facing very well and has a fair,
              balanced and strong approach to solving them. Please join me in
              supporting Jeremiah Pope for County Council At-Large in the
              Democratic Primary.
              <span
                style={{
                  marginLeft: "4px",
                  lineHeight: "0",
                  color: "white",
                }}
              >
                "
              </span>
              <br></br>
              <br></br> —Former Montgomery County Executive Ike Leggett
            </Typography>
            <Grid item mt={2}>
              <Typography
                variant="h3"
                sx={{ mb: 3, fontWeight: 700, color: "#FFF" }}
              >
                Endorsements
              </Typography>
              <List disablePadding>
                {mediaItems.map((item, index) => (
                  <Box key={index}>
                    <ListItem disablePadding>
                      <ListItemButton onClick={item.onClick}>
                        <ListItemText
                          primary={item.title}
                          secondary={item.date}
                          primaryTypographyProps={{
                            sx: {
                              color: "white",
                              fontWeight: "bold",
                              fontSize: "1.1rem",
                            },
                          }}
                          secondaryTypographyProps={{
                            sx: {
                              color: "#aaa",
                              fontSize: "0.85rem",
                            },
                          }}
                        />
                      </ListItemButton>
                    </ListItem>
                    <Divider sx={{ backgroundColor: "#444" }} />
                  </Box>
                ))}
              </List>
            </Grid>
          </Grid>
        </Grid>
      </Box>

      {/* Modal */}
      <EventModal open={eventOpen} handleClose={() => setEventOpen(false)} />

      {/* Footer */}
      <footer>
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          flexDirection="column"
          mt={6}
          mb={4}
          spacing={2}
        >
          <Grid item>
            <Button
              variant="contained"
              color="primary"
              sx={{ textTransform: "none", background: "#00853e!important" }}
              onClick={() => setEmailOpen(true)}
            >
              Join Our Email List
            </Button>
          </Grid>
          <Grid item>
            <IconButton
              component="a"
              href="https://instagram.com/popeforcouncil"
              target="_blank"
              rel="noopener noreferrer"
            >
              <InstagramIcon sx={{ color: "white" }} />
            </IconButton>
            <IconButton
              component="a"
              href="https://twitter.com/popeforcouncil"
              target="_blank"
              rel="noopener noreferrer"
            >
              <TwitterIcon sx={{ color: "white" }} />
            </IconButton>
            <IconButton
              component="a"
              href="https://facebook.com/popeforcouncil"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FacebookIcon sx={{ color: "white" }} />
            </IconButton>
            <IconButton
              component="a"
              href="https://www.youtube.com/@JeremiahPopeForCouncil"
              target="_blank"
              rel="noopener noreferrer"
            >
              <YouTubeIcon sx={{ color: "white" }} />
            </IconButton>
            <IconButton component="a" href="mailto:info@popeforcouncil">
              <EmailIcon sx={{ color: "white" }} />
            </IconButton>
          </Grid>
          <Grid
            item
            sx={{
              border: "1px solid white",
              padding: ".1rem .5rem !important",
              borderRadius: ".25rem!important",
            }}
          >
            <Typography
              variant="h6"
              sx={{ color: "white", fontSize: "1rem!important" }}
            >
              By Authority: Pope For Council, Angie Logan-Pope, Treasurer
            </Typography>
          </Grid>
        </Grid>
      </footer>
      <EmailSignupModal
        open={emailOpen}
        handleClose={() => setEmailOpen(false)}
      />
    </Box>
  );
};

export default Endorsements;
